<template>
  <v-snackbar v-model="snackbar" :timeout="timeout" top>
    {{ text }}
    <template v-slot:actions="{ attrs }">
      <v-btn icon v-bind="attrs" @click="closeSnackbar">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: true,
      text: "Engineering Preview! Click on waves, wind or temperature for a three day time series.",
      timeout: -1, // Keeps the snackbar open until manually closed
    };
  },
  methods: {
    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>

<style scoped></style>
